var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"bar",style:('width:'+_vm.progress+'%')}),_vm._v(" "),_c('p',{staticClass:"progress-text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }